import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className", "title", "isClearable", "components", "isLoading", "style", "label", "arrowColor", "theme", "themeInputBase", "variant", "placeholder", "hint"];
var _templateObject;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputBase from '../InputBase';
import ArrowDown from '../Icons/ArrowDown';
import withTheme from '../theme/withTheme';
var IconArrow = styled(ArrowDown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  width: 24px;\n  height: auto;\n  transition: transform 200ms;\n"])));
var factory = function factory(SelectComponent) {
  var Select = /*#__PURE__*/function (_PureComponent) {
    function Select() {
      _classCallCheck(this, Select);
      return _callSuper(this, Select, arguments);
    }
    _inherits(Select, _PureComponent);
    return _createClass(Select, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          className = _this$props.className,
          title = _this$props.title,
          isClearable = _this$props.isClearable,
          components = _this$props.components,
          isLoading = _this$props.isLoading,
          style = _this$props.style,
          label = _this$props.label,
          arrowColor = _this$props.arrowColor,
          theme = _this$props.theme,
          themeInputBase = _this$props.themeInputBase,
          variant = _this$props.variant,
          placeholder = _this$props.placeholder,
          hint = _this$props.hint,
          rest = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/React.createElement(InputBase, {
          className: className,
          theme: themeInputBase,
          value: rest.value,
          label: label,
          hint: hint,
          variant: variant,
          tooltip: rest.tooltip
        }, /*#__PURE__*/React.createElement(SelectComponent, _extends({
          theme: theme,
          variant: variant,
          placeholder: placeholder,
          className: "react-select-container",
          classNamePrefix: "react-select",
          components: _extends({
            IndicatorSeparator: null,
            DropdownIndicator: function DropdownIndicator(props) {
              return props.selectProps.menuIsOpen ? /*#__PURE__*/React.createElement(IconArrow, {
                stroke: variant === 'error' ? theme.colors.error : theme.colors.primary,
                style: {
                  transform: 'rotate(180deg)'
                }
              }) : /*#__PURE__*/React.createElement(IconArrow, {
                stroke: variant === 'error' ? theme.colors.error : theme.colors.primary
              });
            },
            LoadingIndicator: null
          }, components),
          isClearable: isClearable,
          isLoading: isLoading,
          noOptionsMessage: function noOptionsMessage() {
            return 'Sem registros';
          }
        }, rest)));
      }
    }]);
  }(PureComponent);
  /* overrides some of the default props */
  process.env.NODE_ENV !== "production" ? Select.propTypes = {
    isClearable: PropTypes.bool,
    isLoading: PropTypes.bool,
    components: PropTypes.shape({})
  } : void 0;
  Select.defaultProps = {
    isClearable: false,
    isLoading: false,
    components: {}
  };
  return withTheme(Select);
};
export default factory;